import * as React from 'react';
import Typography from '../components/Typography';
import ProductHeroLayout from './ProductHeroLayout';
import { Link } from '@mui/material';
import backgroundImagePng from '../components/img/heroWatch.png';
import backgroundImageWebp from '../components/img/heroWatch.webp';
import { useWebPSupportCheck } from '../components/img/useWebPSupportCheck';

export default function ProductHero() {
  const supportsWebP = useWebPSupportCheck();

  return (
    <ProductHeroLayout
      sxBackground={{
        backgroundImage: `url(${supportsWebP ? backgroundImageWebp : backgroundImagePng})`,
        backgroundColor: '#1e3c40', // Average color of the background image.
        backgroundPosition: 'center',
      }}
    >
      {/* Increase the network loading priority of the background image. */}
      <img
        style={{ display: 'none' }}
        src={supportsWebP ? backgroundImageWebp : backgroundImagePng}
        alt="increase priority"
      />
      <Typography color="inherit" align="center" variant="h2" marked="center">
        Don't miss another deal
      </Typography>
      <Typography
        color="inherit"
        align="center"
        variant="h5"
        sx={{ mb: 4, mt: { sx: 4, sm: 10 } }}
      >
        Be the first to know when a watch you want is posted on <Link fontStyle={{color: "white"}} href="https://www.reddit.com/r/watchexchange" target="_blank">r/WatchExchange</Link>.
      </Typography>
      <Typography variant="body2" color="inherit" sx={{ mt: 2 }}>
        Scroll down to learn how.
      </Typography>
    </ProductHeroLayout>
  );
}